import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { classNames } from "primereact/utils";
import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FormInput } from "../../components/FormInput";
import { FormTextarea } from "../../components/FormTextarea";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import { B2020104Before, createNoticeRecords, queryNoticeRecordsInfo, updateNoticeRecords } from "../../utility/service/notice-service";
import { checkDpSuccess, getFormErrorMessage, setformate } from "../../utility/service/tool-service";
import { addFormValidator } from "../../utility/validate/formValidator";
import { useEditableFlag } from "../../hooks/useEditableFlag";

export default function NoticeRecord_Create() {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { itemObj, setItemObj, action, setAction } = useOutletContext();
    const [, dispatch] = useContext(MessageContext); //訊息視窗  
    const [editAction, setEditAction] = useState('');//設定目前的動作
    const [detailObj, setDetailObj] = useState({});
    const [releaseStatusList, setReleaseStatusList] = useState([]);
    const [formRule, setFormRule] = useState([]); //表單驗證
    const [typeList, setTypeList] = useState();
    const [effectiveTypeList, setEffectiveTypeList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [membershipLevelList, setMembershipLevelList] = useState([]);
    const isEditable = useEditableFlag('B20201');


    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
    } = useForm({
        defaultValues: {
            title: '',
            content: '',
            useTypes: [],
            effectiveType: [],
            companyLevel: [],
            companyStatus: [],
            releaseStartTime: '',
            releaseEndTime: '',
            releaseStatus: '0'
        },
        //錯誤驗證時機
        mode: "all"
    });

    const axios_getCreateBefore = () => {
        B2020104Before()
            .then((res) => {
                if (checkDpSuccess(res)) {
                    let array = []
                    res?.data?.RespBody?.constraints?.forEach((item) => {
                        const result = addFormValidator(item?.field, res.data.RespBody.constraints);
                        array.push(result)
                    })
                    setFormRule(array);
                }
            })
    }

    const setValidForm = useCallback((formId) => {
        if (formRule?.length > 0) {
            const tmp = formRule?.find((item) => {
                return Object.keys(item)[0] === formId
            });
            return tmp ? tmp[formId] : '';
        }
    }, [formRule]);


    const onSubmit = (data) => {
        let reqBody = {
            useTypes: data.typeList?.join('|'),
            companyStatus: data.statusList?.join('|'),
            effectiveType: data.effectiveTypeList?.join('|'),
            membershipLevel: data.membershipLevelList?.join('|'),
            titleTw: data.titleTw,
            contentTw: data.contentTw,
            titleUs: data.titleUs,
            contentUs: data.contentUs,
            titleVi: data.titleVi,
            contentVi: data.contentVi,
            releaseStartTime: setformate(data.releaseStartTime, "YYYY/MM/DD"),
            releaseEndTime: setformate(data.releaseEndTime, "YYYY/MM/DD"),
            releaseStatus: data.releaseStatus
        }

        if (action === 'create') {
            axios_createNoticeRecords(reqBody);
        } else if (action === 'update') {
            reqBody.noticeSeq = detailObj?.noticeSeq
            axios_updateNoticeRecords(reqBody);
        }

    }


    const checkKeyDown = (e) => {
        if (e.keyCode === 13) {
            e.stopPropagation();
        }
    };

    const inputCheckKeyDown = (e) => { //避免觸發 按enter 後 就觸發 onSubmit 事件冒泡 給input 使用 <FormInput enterClick事件 ; 一般input onKeyDown事件
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    }

    useEffect(() => {
        if (action !== '') {
            if (action !== 'create') {
                axios_queryNoticeRecordsInfo();
            }
            axios_getCreateBefore();
            axios_releaseStatusList();
        } else {
            btnBackTo();
        }
    }, [itemObj])

    useEffect(() => {
        axios_getSubItemsByItemNo("COMPANY_STATUS", 23).then(setStatusList);
        axios_getSubItemsByItemNo("EFFECTIVE_TYPE", 17).then(setEffectiveTypeList);
        axios_getSubItemsByItemNo("COMPANY_LEVEL", 35).then(setMembershipLevelList);

        // axios_getSubItemsByItemNo("ACCT_TYPE", 11).then(setTypeList);
        setTypeList([
            {
                subitemName: t('company.a'), subitemNo: "A"
            },
            {
                subitemName: t('company.b'), subitemNo: "B"
            },
            {
                subitemName: t('company.m'), subitemNo: "M"
            }
        ])

    }, []);

    const axios_getSubItemsByItemNo = (itemNo, orderNo) => {
        return getSubItemsByItemNo(itemNo, orderNo).then((res) => {
            if (checkDpSuccess(res)) {
                let data = res.data.RespBody.subItems;
                return data.map((item, index) => ({
                    ...item,
                    index,
                }));
            }
            return [];
        });
    };

    const btnBackTo = () => {
        navigate("/management/noticeRecord");
    }

    const axios_queryNoticeRecordsInfo = () => {
        queryNoticeRecordsInfo({ noticeSeq: itemObj?.noticeSeq })
            .then((res) => {
                let data = res?.data?.RespBody;
                setDetailObj(data);
                setValue("typeList", data?.useTypes?.split("|"), { shouldValidate: true });
                setValue("statusList", data?.companyStatus?.split("|"), { shouldValidate: true });
                setValue("effectiveTypeList", data?.effectiveType?.split("|"), { shouldValidate: true });
                setValue("membershipLevelList", data?.membershipLevel?.split("|"), { shouldValidate: true });
                setValue("titleTw", data?.titleTw, { shouldValidate: true });
                setValue("contentTw", data?.contentTw, { shouldValidate: true });
                setValue("titleUs", data?.titleUs, { shouldValidate: true });
                setValue("contentUs", data?.contentUs, { shouldValidate: true });
                setValue("titleVi", data?.titleVi, { shouldValidate: true });
                setValue("contentVi", data?.contentVi, { shouldValidate: true });
                setValue("releaseStatus", data?.releaseStatus, { shouldValidate: true });
                setValue("releaseStartTime", new Date(data?.releaseStartTime), { shouldValidate: true });
                setValue("releaseEndTime", new Date(data?.releaseEndTime), { shouldValidate: true })
            })


    }

    const axios_createNoticeRecords = (reqBody) => {
        createNoticeRecords(reqBody)
            .then((res) => {
                if (checkDpSuccess(res)) {
                    handleSuccessMessage(dispatch, t('button.create') + ' ' + t('message.success'));
                    btnBackTo();
                }
            })

    }

    const axios_updateNoticeRecords = (reqBody) => {
        updateNoticeRecords(reqBody)
            .then((res) => {
                if (checkDpSuccess(res)) {
                    handleSuccessMessage(dispatch, t('button.update') + ' ' + t('message.success'));
                    btnBackTo();
                }
            })
    }

    const axios_releaseStatusList = () => {
        getSubItemsByItemNo('RELEASE_STATUS', 19)
            .then((res) => {
                if (checkDpSuccess(res)) {
                    let data = res.data.RespBody.subItems;
                    let newArray = data.map((item, index) => {
                        return {
                            ...item,
                            index: index,
                        }
                    })
                    setReleaseStatusList(newArray);
                }
            })
    }

    return (<>
        {/* 返回上頁 */}
        <div className="flex justify-content-between flex-wrap align-items-center">
            <div className="align-items-start">
                <Button rounded text onClick={() => { btnBackTo(); }}>
                    <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
                    {t('button.return_to_list')}
                </Button>
            </div>
        </div>
        <div className="p-card">
            <div className="p-card-body">
                <form onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
                    <div className="grid">
                        {/* 中文標題 */}
                        <div className="col-12">
                            <FormInput
                                rules={setValidForm("titleTw")}
                                disabled={action === 'detail' || !isEditable}
                                register={register}
                                errors={errors}
                                id="titleTw"
                                type="text"
                                labelClass={`control-label ${action !== 'detail' ? 'required' : ''}`}
                                enterClick={inputCheckKeyDown}
                                labelText={t('titleTw')}
                            />
                        </div>
                        {/* 英文標題 */}
                        <div className="col-12">
                            <FormInput
                                rules={setValidForm("titleUs")}
                                disabled={action === 'detail' || !isEditable}
                                register={register}
                                errors={errors}
                                id="titleUs"
                                type="text"
                                labelClass={`control-label ${action !== 'detail' ? 'required' : ''}`}
                                enterClick={inputCheckKeyDown}
                                labelText={t('titleUs')}
                            />
                        </div>
                        {/* 越文標題 */}
                        <div className="col-12">
                            <FormInput
                                rules={setValidForm("titleVi")}
                                disabled={action === 'detail' || !isEditable}
                                register={register}
                                errors={errors}
                                id="titleVi"
                                type="text"
                                labelClass={`control-label ${action !== 'detail' ? 'required' : ''}`}
                                enterClick={inputCheckKeyDown}
                                labelText={t('titleVi')}
                            />
                        </div>
                    </div>
                    <div className="grid">
                        {/* 身份別 */}
                        <div className="col-3">
                            <label htmlFor="typeList" className={`form-label ${action !== 'detail' ? 'required' : ''}`}>
                                {t("useType")}
                            </label>
                            <Controller
                                name="typeList"
                                control={control}
                                rules={setValidForm("useTypes")}
                                render={({ field }) => (
                                    <MultiSelect
                                        filter
                                        showClear
                                        className="w-full"
                                        disabled={action === 'detail' || !isEditable}
                                        style={{ width: "100%" }}
                                        display="chip"
                                        options={typeList}
                                        optionLabel={"subitemName"}
                                        optionValue={"subitemNo"}
                                        maxSelectedLabels={3}
                                        value={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.value);
                                        }}
                                    ></MultiSelect>
                                )}
                            />
                            {getFormErrorMessage(errors, "typeList")}
                        </div>

                        {/* 狀態 */}
                        <div className="col-3">
                            <label htmlFor="statusList" className={`form-label ${action !== 'detail' ? 'required' : ''}`}>
                                {t("reviewStatusDistribution")}
                            </label>
                            <Controller
                                name="statusList"
                                control={control}
                                rules={setValidForm("companyStatus")}
                                render={({ field }) => (
                                    <MultiSelect
                                        filter
                                        showClear
                                        className="w-full"
                                        disabled={action === 'detail' || !isEditable}
                                        style={{ width: "100%" }}
                                        display="chip"
                                        options={statusList}
                                        optionLabel={"subitemName"}
                                        optionValue={"subitemNo"}
                                        maxSelectedLabels={3}
                                        value={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.value);
                                        }}
                                    ></MultiSelect>
                                )}
                            />
                            {getFormErrorMessage(errors, "statusList")}
                        </div>

                        {/* 授權類型 */}
                        <div className="col-3">
                            <label htmlFor="effectiveTypeList" className={`form-label ${action !== 'detail' ? 'required' : ''}`}>
                                {t("authorizationType")}
                            </label>
                            <Controller
                                name="effectiveTypeList"
                                control={control}
                                rules={setValidForm("effectiveType")}
                                render={({ field }) => (
                                    <MultiSelect
                                        filter
                                        showClear
                                        className="w-full"
                                        disabled={action === 'detail' || !isEditable}
                                        style={{ width: "100%" }}
                                        display="chip"
                                        options={effectiveTypeList}
                                        optionLabel={"subitemName"}
                                        optionValue={"subitemNo"}
                                        maxSelectedLabels={3}
                                        value={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.value);
                                        }}
                                    ></MultiSelect>
                                )}
                            />
                            {getFormErrorMessage(errors, "effectiveTypeList")}
                        </div>


                        {/* 會員等級 */}
                        <div className="col-3">
                            <label htmlFor="membershipLevelList" className={`form-label ${action !== 'detail' ? 'required' : ''}`}>
                                {t("membershipLevel")}
                            </label>
                            <Controller
                                name="membershipLevelList"
                                control={control}
                                rules={setValidForm("membershipLevel")}
                                render={({ field }) => (
                                    <MultiSelect
                                        filter
                                        showClear
                                        className="w-full"
                                        disabled={action === 'detail' || !isEditable}
                                        style={{ width: "100%" }}
                                        display="chip"
                                        options={membershipLevelList}
                                        optionLabel={"subitemName"}
                                        optionValue={"subitemNo"}
                                        maxSelectedLabels={3}
                                        value={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.value);
                                        }}
                                    ></MultiSelect>
                                )}
                            />
                            {getFormErrorMessage(errors, "membershipLevelList")}
                        </div>

                        {/* 發布時間 */}
                        <div className="col-12 lg:col-8">
                            <label
                                htmlFor="useTypes"
                                className={`form-label ${action !== 'detail' ? 'required' : ''}`}>
                                {t("postingTime")}
                            </label>
                            <div className="col-date-picker">

                                <Controller
                                    name="releaseStartTime"
                                    control={control}
                                    rules={{
                                        required: { value: true, message: t('validation.required') },
                                        validate: (val) => {
                                            if ((val !== "" && watch('releaseEndTime') !== '') && watch('releaseEndTime') < val) return t('validation.startDate')
                                        },
                                    }}
                                    render={({
                                        field,
                                        fieldState,
                                        formState,
                                    }) => (
                                        // <div>
                                        <Calendar
                                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                                            dateFormat='yy-mm-dd'
                                            disabled={action === 'detail' || !isEditable}
                                            value={field.value || ''}
                                            onChange={(e) => {
                                                field.onChange(e.value)
                                                if (e.value < watch("releaseEndTime")) {
                                                    clearErrors("releaseEndTime")
                                                }
                                            }}
                                            showIcon />

                                        // </div>

                                    )} />
                                {getFormErrorMessage(errors, "releaseStartTime")}

                                <Controller
                                    name="releaseEndTime"
                                    control={control}
                                    rules={{
                                        required: { value: true, message: t('validation.required') },
                                        validate: (val) => {
                                            if ((val !== '' && watch('releaseStartTime') !== '') && watch('releaseStartTime') > val) return t('validation.endDate')
                                        },
                                    }}
                                    render={({
                                        field,
                                        fieldState,
                                        formState,
                                    }) => (
                                        // <div>
                                        <Calendar
                                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                                            dateFormat='yy-mm-dd'
                                            disabled={action === 'detail' || !isEditable}
                                            value={field.value || ''}
                                            onChange={(e) => {
                                                field.onChange(e.value);
                                                if (e.value > watch("releaseStartTime")) {
                                                    clearErrors("releaseStartTime")
                                                }
                                            }}
                                            showIcon />
                                        // </div>

                                    )} />
                                {getFormErrorMessage(errors, "releaseEndTime")}
                            </div>
                        </div>


                        {/* 狀態 */}
                        <div className='col-12 lg:col-2'>
                            <label
                                htmlFor="releaseStatus"
                                className={`form-label ${action !== 'detail' ? 'required' : ''}`}>
                                {t("status")}
                            </label>
                            <Controller
                                name="releaseStatus"
                                control={control}
                                rules={setValidForm("releaseStatus")}
                                render={({ field, fieldState }) => (
                                    <Dropdown
                                        filter
                                        disabled={action === 'detail' || !isEditable}
                                        optionLabel="subitemName"
                                        optionValue="subitemNo"
                                        value={field.value}
                                        virtualScrollerOptions={{ itemSize: 40 }}
                                        defaultValue={""}
                                        placeholder={t("plz_chs")}
                                        name="releaseStatus"
                                        control={control}
                                        options={releaseStatusList}
                                        className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                                        onChange={(event) => {
                                            field.onChange(event.value);
                                        }}
                                    />
                                )}
                            />
                            {getFormErrorMessage(errors, "releaseStatus")}

                        </div>


                    </div>
                    <div className="grid">
                        {/* 中文內容 */}
                        <div className="col-12">
                            <FormTextarea
                                disabled={action === 'detail' || !isEditable}
                                register={register}
                                errors={errors}
                                id="contentTw"
                                name="contentTw"
                                type="text"
                                labelText={t('contentTw')}
                                labelClass={`control-label ${action !== 'detail' ? 'required' : ''}`}
                                areaClass="w-full"
                                placeholder={''}
                                rules={action !== 'detail' ? setValidForm("contentTw") : ''}

                            />
                        </div>
                        {/* 英文內容 */}
                        <div className="col-12">
                            <FormTextarea
                                disabled={action === 'detail' || !isEditable}
                                register={register}
                                errors={errors}
                                id="contentUs"
                                name="contentUs"
                                type="text"
                                labelText={t('contentUs')}
                                labelClass={`control-label ${action !== 'detail' ? 'required' : ''}`}
                                areaClass="w-full"
                                placeholder={''}
                                rules={action !== 'detail' ? setValidForm("contentUs") : ''}

                            />
                        </div>
                        {/* 越文內容 */}
                        <div className="col-12">
                            <FormTextarea
                                disabled={action === 'detail' || !isEditable}
                                register={register}
                                errors={errors}
                                id="contentVi"
                                name="contentVi"
                                type="text"
                                labelText={t('contentVi')}
                                labelClass={`control-label ${action !== 'detail' ? 'required' : ''}`}
                                areaClass="w-full"
                                placeholder={''}
                                rules={action !== 'detail' ? setValidForm("contentVi") : ''}

                            />
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 lg:col-3">
                            <label
                                className="form-label">
                                {t("create_user")}
                            </label>
                            <span>{detailObj?.createUser}</span>
                        </div>
                        <div className="col-12 lg:col-3">
                            <label
                                className="form-label">
                                {t("create_date")}
                            </label>
                            <span>{detailObj?.createDateTime}</span>
                        </div>
                        <div className="col-12 lg:col-3">
                            <label
                                className="form-label">
                                {t("update_user")}
                            </label>
                            <span>{detailObj?.updateUser}</span>
                        </div>
                        <div className="col-12 lg:col-3">
                            <label
                                className="form-label">
                                {t("update_date")}
                            </label>
                            <span>{detailObj?.updateDateTime}</span>
                        </div>
                        <div className="col-12 lg:col-3">
                            <label
                                className="form-label">
                                {t("mailUser")}
                            </label>
                            <span>{detailObj?.mailUser}</span>
                        </div>
                        <div className="col-12 lg:col-3">
                            <label
                                className="form-label">
                                {t("mailDateTime")}
                            </label>
                            <span>{detailObj?.mailDateTime}</span>
                        </div>
                    </div>

                    <div className="col-12 gap-2 flex-all-center">
                        {
                            (action === 'detail') ? (<div className="col-12 gap-2 flex-all-center">
                                <Button disabled={!isEditable} label={t("button.edit")} onClick={(e) => {
                                    e.preventDefault();
                                    setAction('update');
                                }} type="button" size="small" />
                            </div>) : (<>
                                <Button disabled={!isValid || !isEditable} type="submit" label={t("button.confirm")} size="small" />
                                <Button outlined size="small" type="button" label={t("button.cancel")} onClick={(e) => {
                                    btnBackTo();
                                }} />
                            </>)
                        }
                    </div>

                </form>

            </div>
        </div>
    </>)
}